export const DOC_TYPE_OPTIONS = [
  'FIE',
  'IEP',
  'FVE',
  'LMA',
  'ARD-NOTES',
  'PROGRESS',
  'ECC',
  'CORR',
] as const;

export type DocTypeOption = (typeof DOC_TYPE_OPTIONS)[number];

export function getCurrentYearMonth(): string {
  return new Date().toISOString().slice(0, 7);
}

export function getFileExtension(fileName: string): string {
  if (fileName === 'Pasted Text') return 'txt';
  const ext = fileName.split('.').pop();
  if (!ext || ext === fileName) return 'txt';
  return ext.toLowerCase();
}

export function buildRedactedFilename(
  studentCode: string,
  docType: DocTypeOption,
  yearMonth: string,
  extension: string
): string {
  const sanitizedCode = studentCode.trim().replace(/\s+/g, '');
  return `${sanitizedCode}_${docType}_REDACTED_${yearMonth}.${extension}`;
}
